module.exports = __webpack_public_path__ + "static/media/team_frank.17486a5e.jpg";